var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.996,
    height: 22,
    viewBox: "0 0 17.996 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16295",
    "data-name": "Path 16295",
    d: "M6292.385,358.893v-6.617a6.06,6.06,0,0,0-5.5-6.026V345h-1.222v1.25a6.06,6.06,0,0,0-5.5,6.026v6.617l-2.887,5.051h5.942a3.055,3.055,0,1,0,6.111,0h5.943Zm-4.754,3.829h-8.248l2-3.5v-6.942a4.838,4.838,0,0,1,4.832-4.832h.115a4.838,4.838,0,0,1,4.832,4.832v6.942l2,3.5h-5.534Zm-1.357,3.056a1.836,1.836,0,0,1-1.833-1.833h3.667A1.836,1.836,0,0,1,6286.274,365.778Z",
    transform: "translate(-6277.276 -345)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.c63c34f6.svg";
export { ForwardRef as ReactComponent };